import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'firstName',
    label: 'First Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'middleName',
    label: 'Middle Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'lastName',
    label: 'Last Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'suffix',
    label: 'Suffix',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const alternateNamesForm = {
  name: FormNames.ALTERNATE_NAMES,
  label: 'Alternate Names',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
